import React, { useEffect, useState } from "react";
import "./style.css";
import { useParams } from "react-router-dom";
import localforage from "localforage";
import { useAppServices } from "hook/services";
import env from "../../config";
import PrivacyPolicyModal from "./PrivacyPolicyModal";

const SSOCheck = () => {
  const [ssoKey, setSsoKey] = useState("");
  const [agencyData, setAgencyData] = useState(null);
  const [validationError, setValidationError] = useState(null);
  const [processing, setProcessing] = useState(false);
  const [iframeUrl, setIframeUrl] = useState("");
  const [agreed, setAgreed] = useState(false);
  const [open, setOpen] = useState(false);

  const params = useParams();
  const Service = useAppServices();
  const Account_level = env.ACCOUNT_LEVEL_URL;

  useEffect(() => {
    const fetchAgencyData = async () => {
      try {
        const token = await localforage.getItem("token");
        const { response } = await Service.agency.GetByLocation({
          query: `location_id=${params?.locationId}`,
          token,
        });
        if (response?.data) {
          setAgencyData(response.data);
        }
      } catch (error) {
        console.error("Error fetching agency data:", error);
      }
    };

    fetchAgencyData();
  }, [params.locationId]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setProcessing(true);
    setValidationError(null);
    if (!agreed) {
      setProcessing(false);
      setValidationError({
        success: true,
        message: "Please check the privacy policy to verify api key!",
      });
    }
    if (!agencyData) {
      setValidationError({ success: false, message: "Agency data not available." });
      setProcessing(false);
      return;
    }

    try {
      const payload = {
        _id: agencyData?._id,
        external_key: ssoKey,
        privacy_policy: {
          checked: agreed,
          date: new Date(),
        },
      };

      const { response } = await Service.agency.ValidateApiKey({ payload });

      if (response?.success) {
        setValidationError({ success: true, message: "Your API key is valid!" });
        setIframeUrl(`${Account_level}/${agencyData?.email}/${agencyData?._id}/dashboard`);
      } else {
        setValidationError({ success: false, message: "Invalid API key. Please try again." });
      }
    } catch (error) {
      console.error("Error validating API key:", error);
      setValidationError({ success: false, message: "An error occurred. Please try again." });
    }

    setProcessing(false);
  };

  return (
    <div className="sso-container">
      {iframeUrl ? (
        <iframe
          src={iframeUrl}
          className="sso-iframe"
          title="SSO Access"
          style={{ width: "100%", height: "100vh", border: "none" }}
        ></iframe>
      ) : (
        <form className="sso-form" onSubmit={handleSubmit}>
          <img
            src="https://snapshotstore.fra1.digitaloceanspaces.com/Untitled%20design%20%287%29-83731"
            alt="Logo"
            className="sso-logo"
          />
          <h2 className="sso-heading">
            You don&apos;t have access. Please add your License Key to verify.
          </h2>

          <input
            type="text"
            className="sso-input"
            placeholder="Enter License Key"
            value={ssoKey}
            onChange={(e) => setSsoKey(e.target.value)}
          />

          {/* ✅ Privacy Policy Checkbox */}
          <label
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              marginBottom: "1rem",
            }}
          >
            <input
              type="checkbox"
              checked={agreed}
              onChange={(e) => setAgreed(e.target.checked)}
              required
            />
            <PrivacyPolicyModal open={open} onClose={() => setOpen(false)} />
            <span style={{ display: "flex", gap: "5px" }}>
              <p>I agree to the</p>
              <a
                onClick={() => setOpen(true)}
                style={{
                  color: "#008cff",
                  cursor: "pointer",
                }}
              >
                terms & conditions
              </a>
            </span>
          </label>

          <button type="submit" className="sso-button" disabled={processing}>
            {processing ? "Verifying..." : "Verify"}
          </button>

          {validationError && (
            <p className={`sso-message ${validationError.success ? "success" : "error"}`}>
              {validationError.message}
            </p>
          )}
        </form>
      )}
    </div>
  );
};

export default SSOCheck;
